import { listStatuses } from '../thunks/statuses';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const statusesReducers = (builder) => {
  // list property statuses
  builder
    .addCase(listStatuses.fulfilled, (state, action) => handleFulfilled(state, 'statuses', action))
    .addCase(listStatuses.pending, (state) => handlePending(state, 'statuses'))
    .addCase(listStatuses.rejected, (state) => handleRejected(state, 'statuses'));
};
